var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{class:_vm.type == 'password' ? 'input-password-' : '',attrs:{"type":'text',"id":"meu-input","value":_vm.passwordValue},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }